import { cn } from '@fshr/shared-react';

export function HorizontalLine({
	additionalClasses,
}: {
	additionalClasses?: string | string[] | Record<string, boolean>;
}) {
	return <hr className={cn('w-full border-t-[1px] border-border-default', additionalClasses)} />;
}
